/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentReminderPreferenceRequest
 */
export interface AppointmentReminderPreferenceRequest {
    /**
     * Is today reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceRequest
     */
    isTodayReminderEnabled?: boolean;
    /**
     * Is the one day before reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceRequest
     */
    isOneDayBeforeReminderEnabled?: boolean;
    /**
     * Is the three days before reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceRequest
     */
    isThreeDaysBeforeReminderEnabled?: boolean;
    /**
     * Is the one week before reminder enabled
     * @type {boolean}
     * @memberof AppointmentReminderPreferenceRequest
     */
    isOneWeekReminderEnabled?: boolean;
}

/**
 * Check if a given object implements the AppointmentReminderPreferenceRequest interface.
 */
export function instanceOfAppointmentReminderPreferenceRequest(value: object): value is AppointmentReminderPreferenceRequest {
    return true;
}

export function AppointmentReminderPreferenceRequestFromJSON(json: any): AppointmentReminderPreferenceRequest {
    return AppointmentReminderPreferenceRequestFromJSONTyped(json, false);
}

export function AppointmentReminderPreferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentReminderPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isTodayReminderEnabled': json['isTodayReminderEnabled'] == null ? undefined : json['isTodayReminderEnabled'],
        'isOneDayBeforeReminderEnabled': json['isOneDayBeforeReminderEnabled'] == null ? undefined : json['isOneDayBeforeReminderEnabled'],
        'isThreeDaysBeforeReminderEnabled': json['isThreeDaysBeforeReminderEnabled'] == null ? undefined : json['isThreeDaysBeforeReminderEnabled'],
        'isOneWeekReminderEnabled': json['isOneWeekReminderEnabled'] == null ? undefined : json['isOneWeekReminderEnabled'],
    };
}

export function AppointmentReminderPreferenceRequestToJSON(json: any): AppointmentReminderPreferenceRequest {
    return AppointmentReminderPreferenceRequestToJSONTyped(json, false);
}

export function AppointmentReminderPreferenceRequestToJSONTyped(value?: AppointmentReminderPreferenceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isTodayReminderEnabled': value['isTodayReminderEnabled'],
        'isOneDayBeforeReminderEnabled': value['isOneDayBeforeReminderEnabled'],
        'isThreeDaysBeforeReminderEnabled': value['isThreeDaysBeforeReminderEnabled'],
        'isOneWeekReminderEnabled': value['isOneWeekReminderEnabled'],
    };
}

